import { EMPTY_LIST } from '../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'

export const ENTITY_TAB_POSTS_FILTER_SUB_MENU = 'newsboard'

export const ENTITY_TAB_POSTS_EXCLUDE_FILTERS = [FILTER_NAME_SUB_MENU]

export const ENTITY_TAB_POSTS_SEARCH_FILTER_KEY = 'search_query'

export const ENTITY_TAB_POSTS_SCALAR_SCOPE_FILTER_KEYS = ['for_building_group']

export const ENTITY_TAB_POSTS_SEARCH_TIMEOUT = 300

export const ENTITY_TAB_POSTS_SEARCH_MAX_LENGTH = 256

export const ENTITY_TAB_POSTS_DEFAULT_QA_NAME = 'entityTabPosts'

export const ENTITY_TAB_POSTS_ORDERING_VALUE = {
  default: 'default',
  newest: 'newest',
  oldest: 'oldest',
}

export const ENTITY_TAB_POSTS_ORDERING_OPTIONS = {
  [ENTITY_TAB_POSTS_ORDERING_VALUE.default]: EMPTY_LIST,
  [ENTITY_TAB_POSTS_ORDERING_VALUE.newest]: ['-date_from'],
  [ENTITY_TAB_POSTS_ORDERING_VALUE.oldest]: ['date_from'],
}

export const ENTITY_TAB_POSTS_DEFAULT_ORDERING_VALUE =
  ENTITY_TAB_POSTS_ORDERING_VALUE.newest
